import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "#212121",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M704.268 51.853L712 44.121l7.732 7.732c.195.195.512.195.707 0l1.414-1.414c.195-.195.195-.512 0-.707L714.121 42l7.732-7.732c.195-.195.195-.512 0-.707l-1.414-1.414c-.195-.195-.512-.195-.707 0L712 39.879l-7.732-7.733c-.195-.195-.512-.195-.707 0l-1.415 1.415c-.195.195-.195.512 0 .707L709.88 42l-7.733 7.732c-.195.195-.195.512 0 .707l1.415 1.414c.195.195.512.195.707 0z",
				transform: "translate(-1670.000000, -591.000000) translate(968.000000, 559.000000)"
			}) })
		})
	})
});
export default SvgClose;
